import React from 'react';
import Dot from 'components/Dot';
import styled from 'styled-components';
import { Divider } from 'antd';

import { getOTAMessage } from './service';
import { toPercent, toCurrency } from '../../helpers/numberHelper';

const StyledRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    min-width: 600px;
    width: 100%;
    padding: 0px;
`;

const StyledTitleRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    min-width: 600px;
    width: 100%;
    padding: 0px;
    font-size: 14px;
    font-weight: bold;
`;

const StyledRowItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 10px;
`;

export const MEAL = {
    0: 'Room only',
    1: 'Breakfast included',
    2: 'Half board included',
    3: 'Full board included',
    4: 'All inclusive',
    5: 'Room Only',
};

const Tooltip = (props) => {
    const { active, payload, label, demand } = props;
    if (!(active && payload && payload[0])) return null;

    const date = payload[0].payload.date.format('YYYY-MM-DD');
    const demandValue = demand[date] ? toPercent(demand[date]) : 'N/A';

    return (
        <div className="tooltip">
            <div className="tooltip-header">{label}</div>
            <div className="tooltip-content" id="marketDemand">
                <div className="tooltip-content-section">
                    <div className="tooltip-header">Market demand: {demandValue}</div>
                </div>
            </div>
            <div className="tooltip-content">
                <div className="tooltip-content-section">
                    <StyledTitleRow>
                        <div style={{ width: '20px' }} />
                        <StyledRowItem style={{ width: '25%' }}>Property</StyledRowItem>
                        <StyledRowItem style={{ width: '10%' }}>Value</StyledRowItem>
                        <StyledRowItem style={{ width: '30%' }}>Room name</StyledRowItem>
                        <StyledRowItem style={{ width: '15%' }}>Room Type</StyledRowItem>
                        <StyledRowItem style={{ width: '20%' }}>Meal?</StyledRowItem>
                    </StyledTitleRow>
                </div>
            </div>
            <Divider style={{ marginTop: '5px' }} />
            <div className="tooltip-content">
                <div className="tooltip-content-section">
                    {payload.map((row) => {
                        const { value, name, stroke } = row;
                        const { currency, message, roomName, roomType, mealTypeIncluded } = row.payload[name];

                        const displayValue = value === undefined ? getOTAMessage(message) : toCurrency(value, currency);

                        const mealText = value === undefined ? '' : MEAL[mealTypeIncluded];

                        return (
                            <StyledRow>
                                <Dot colour={stroke} />
                                <StyledRowItem style={{ width: '25%' }}>{name}:</StyledRowItem>
                                <StyledRowItem style={{ width: '10%' }}>{displayValue}</StyledRowItem>
                                <StyledRowItem style={{ width: '30%' }}>{roomName}</StyledRowItem>
                                <StyledRowItem style={{ width: '15%' }}>{roomType}</StyledRowItem>
                                <StyledRowItem style={{ width: '20%' }}>{mealText}</StyledRowItem>
                            </StyledRow>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Tooltip;
